import { CurrencyPaymentStatus } from '@/interfaces/billing'

// Status option interface
export interface StatusOption {
  label: string
  value: string
}

export const STATUS_LABELS: Record<CurrencyPaymentStatus, string> = {
  REFUND: 'Reembolsado',
  PREPAID_PAYMENT: 'Anticipado',
  PARTIAL_PAYMENT: 'Parcial',
  CONFIRMED_PAYMENT: 'Confirmado',
}

// Status type options
export const statusOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Currency options
export const codeCurrencyOptions: StatusOption[] = [
  { label: 'CUP', value: 'CUP' },
  { label: 'USD', value: 'USD' },
  { label: 'EUR', value: 'EUR' },
  { label: 'MLC', value: 'MLC' },
]
